<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col class="col-md-12 col-sm-12 col-lg-12">
        <b-card>
          <div slot="header">
            <strong v-text="$lang.change_password" />
          </div>
          <LoadingSpinner :loading="isLoading" :text="loadingSpinnerText" />
          <b-form @submit.prevent="save" v-show="!isLoading">
            <b-form-group
              :label="$lang.username"
              label-for="username"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.username"
                :rules="$v.username.$params"
              />
              <small class="form-text text-left text-info mb-1">
                <i class="fas fa-info-circle" />
                <span
                  class="ml-1"
                  v-text="
                    'نام کاربری فقط عدد یا حرف یا ترکیب هر دو و حداقل 3 کارکتر باشد.'
                  "
                />
              </small>
              <b-form-input
                id="username"
                type="text"
                :autocomplete="$lang.username"
                :state="$v.username.$dirty ? !$v.username.$error : null"
                v-model="$v.username.$model"
              ></b-form-input>
              <b-form-invalid-feedback id="username-feedback"
                >{{ $lang.error_required | replace($lang.username) }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              :label="$lang.email"
              label-for="email"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.email"
                :rules="$v.email.$params"
              />
              <b-form-input
                id="email"
                type="email"
                :autocomplete="$lang.email"
                :state="$v.email.$dirty ? !$v.email.$error : null"
                v-model="$v.email.$model"
              ></b-form-input>
              <b-form-invalid-feedback id="email-feedback"
                >{{ $lang.error_required | replace($lang.email) }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              :label="$lang.mobile"
              label-for="mobile"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.mobile"
                :rules="$v.mobile.$params"
              />
              <b-form-input
                id="mobile"
                type="text"
                :autocomplete="$lang.mobile"
                :state="$v.mobile.$dirty ? !$v.mobile.$error : null"
                v-model="$v.mobile.$model"
                :disabled="true"
              ></b-form-input>
              <b-form-invalid-feedback id="mobile-feedback"
                >{{ $lang.error_required | replace($lang.mobile) }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              :label="$lang.current_password"
              label-for="current_password"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.current_password"
                :rules="$v.current_password.$params"
              />
              <b-input-group>
                <b-form-input
                  id="current_password"
                  :type="show_current_password ? 'text' : 'password'"
                  :autocomplete="$lang.current_password"
                  :state="
                    $v.current_password.$dirty
                      ? !$v.current_password.$error
                      : null
                  "
                  v-model="$v.current_password.$model"
                ></b-form-input>
                <b-input-group-text
                  @click.prevent="toggleShowCurrentVisible"
                  style="cursor: pointer"
                >
                  <a href="#">
                    <i
                      :class="
                        show_current_password ? 'fa fa-eye' : 'fa fa-eye-slash'
                      "
                      aria-hidden="true"
                    ></i>
                  </a>
                </b-input-group-text>
                <b-form-invalid-feedback id="current_password-feedback">
                  {{
                    $lang.error_required | replace($lang.current_password)
                  }}</b-form-invalid-feedback
                >
              </b-input-group>
            </b-form-group>

            <b-form-group
              :label="$lang.new_password"
              label-for="new_password"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.new_password"
                :rules="$v.new_password.$params"
              />
              <b-input-group>
                <b-form-input
                  id="new_password"
                  :type="show_new_password ? 'text' : 'password'"
                  :autocomplete="$lang.new_password"
                  :state="
                    $v.new_password.$dirty ? !$v.new_password.$error : null
                  "
                  v-model="$v.new_password.$model"
                ></b-form-input>
                <b-input-group-text
                  @click.prevent="toggleShowNewVisible"
                  style="cursor: pointer"
                >
                  <a href="#">
                    <i
                      :class="
                        show_new_password ? 'fa fa-eye' : 'fa fa-eye-slash'
                      "
                      aria-hidden="true"
                    ></i>
                  </a>
                </b-input-group-text>
                <b-form-invalid-feedback id="new_password-feedback">
                  {{
                    $lang.error_required | replace($lang.new_password)
                  }}</b-form-invalid-feedback
                >
              </b-input-group>
              <small class="form-text text-muted text-left">{{
                $lang.password_template
              }}</small>
            </b-form-group>

            <b-form-group
              :label="$lang.confirm_password"
              label-for="confirm_password"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.confirm_password"
                :rules="$v.confirm_password.$params"
              />
              <b-input-group>
                <b-form-input
                  id="confirm_password"
                  :type="show_confirm_password ? 'text' : 'password'"
                  :autocomplete="$lang.confirm_password"
                  :state="
                    $v.confirm_password.$dirty
                      ? !$v.confirm_password.$error
                      : null
                  "
                  v-model="$v.confirm_password.$model"
                ></b-form-input>
                <b-input-group-text
                  @click.prevent="toggleShowConfirmVisible"
                  style="cursor: pointer"
                >
                  <a href="#">
                    <i
                      :class="
                        show_confirm_password ? 'fa fa-eye' : 'fa fa-eye-slash'
                      "
                      aria-hidden="true"
                    ></i>
                  </a>
                </b-input-group-text>
                <b-form-invalid-feedback id="confirm_password-feedback">
                  {{
                    $lang.error_required | replace($lang.confirm_password)
                  }}</b-form-invalid-feedback
                >
              </b-input-group>
              <small class="form-text text-muted text-left">{{
                $lang.password_template
              }}</small>
            </b-form-group>

            <div slot="footer" class="form-group form-btn">
              <b-button
                type="submit"
                v-if="showPermissionButton"
                size="md"
                variant="success"
              >
                {{ $lang.submitButton }}
                <i class="fa fa-check"></i>
              </b-button>

              <b-button
                class="ml-2"
                size="md"
                variant="danger"
                @click="handleBack"
              >
                {{ $lang.cancelButton }}
                <i class="fa fa-ban"></i>
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import LoadingSpinner from "@/components/base/LoadingSpinner";

export default {
  name: "change-pass",
  components: {
    LoadingSpinner,
  },
  validations: {
    email: {
      email,
    },
    username: {
      required,
    },
    mobile: {},
    current_password: {
      required,
    },
    new_password: {
      required,
    },
    confirm_password: {
      required,
    },
  },
  data() {
    return {
      isLoading: false,
      id: this.$route.params.id,
      email: "",
      mobile: "",
      username: "",
      current_password: "",
      new_password: "",
      confirm_password: "",
      show_current_password: false,
      show_new_password: false,
      show_confirm_password: false,
      permission: [],
      allowPermissions: ["admin", "edit"],
      showPermissionButton: false,
      loadingSpinnerText: this.$lang.receiving_data,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    includes,
    permissionButtons() {
      this.showPermissionButton = this.permission.some((item) =>
        includes(item, this.allowPermissions)
      );
    },
    toggleShowCurrentVisible() {
      this.show_current_password = !this.show_current_password;
    },
    toggleShowNewVisible() {
      this.show_new_password = !this.show_new_password;
    },
    toggleShowConfirmVisible() {
      this.show_confirm_password = !this.show_confirm_password;
    },
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      this.email = "";
      this.mobile = "";
      this.username = "";
      this.current_password = "";
      this.new_password = "";
      this.confirm_password = "";
    },
    changes() {},
    afterSave() {
      if (this.backUrl) {
        this.$router.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.loadingSpinnerText = this.$lang.sending_data;
        this.isLoading = true;
        const url = `${this.$config.api_url}${this.$config.resources.user}/change_pass`;
        const payload = {
          email: this.email,
          mobile: this.mobile,
          username: this.username,
          current_password: this.current_password,
          password: this.new_password,
          password_confirmation: this.confirm_password,
        };
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
        this.afterSave();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchData() {
      try {
        this.loadingSpinnerText = this.$lang.receiving_data;
        this.isLoading = true;
        const url =
          this.$config.api_url + this.$config.resources.profile_change_pass;
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.permission = response.data.permissions;
        this.username = pathOr(null, ["username"], data);
        this.email = pathOr(null, ["email"], data);
        this.mobile = pathOr(null, ["mobile"], data);
        this.permissionButtons();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

